import { render, staticRenderFns } from "./ColaborativeBoard.vue?vue&type=template&id=66d10a14&"
import script from "./ColaborativeBoard.vue?vue&type=script&lang=js&"
export * from "./ColaborativeBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports